import Subject from './Subject'
import BankAccount from './BankAccount'

export default class NewSubject {
  constructor(component, isCnpj) {
    this.component = component
    this.isCnpj = isCnpj
  }
  name() {
    if (this.isCnpj) {
      return 'new-company-subject'
    }
    return 'new-person-subject'
  }
  handle(event) {
    if(event.cancel) {
      this.component.modalExpanded = false
      this.component.transaction_controller = new Subject(this.component)
      return
    }
    if(event.newSubject) {
      this.component.modalExpanded = false
      this.component.selected_subject = event.newSubject
      this.component.transaction_controller = new BankAccount(this.component)
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/NewTransaction/NewSubject.js